<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon
          slot="icon-only"
          name="chevron-back"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <div class="tab-container">
      <h4
        [class.active]="selectedPage() === 'requests-list'"
        (click)="segmentChanged('requests-list')"
      >
        {{ 'Requests_title' | translate }}
      </h4>
      @if (fieldProvider.requestPageEnabled$ | async) {
        <h4
          [class.active]="selectedPage() === 'requests-create'"
          (click)="segmentChanged('requests-create')"
        >
          {{ 'New_request_title' | translate }}
        </h4>
      }
    </div>
    <ion-buttons
      [opacity]="0"
      [rotaDisable]="selectedPage() !== 'requests-list'"
      slot="end"
    >
      <ion-button (click)="showFilters()">
        <ion-icon
          slot="icon-only"
          [name]="sortBy() !== filterBy.None ? 'funnel' : 'funnel-outline'"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    @if (isLoading()) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-refresher
    slot="fixed"
    (ionRefresh)="handleRefresh($event)"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <!-- Requests content -->
  @if (selectedPage() === 'requests-list') {
    <div
      class="page-content requests-list"
      rotaAnimate
      [delayShowAnimation]="200"
      [animationHideTransitionMS]="300"
      [animateToggle]="selectedPage() === 'requests-list'"
    >
      @if (showSortLabel) {
        <div class="sortby-wrapper">
          <p class="sortby-label">{{ 'Request_filter_sorted_by' | translate }}</p>
          <p class="sortby-name">{{ getSortName() }}</p>
        </div>
      }

      @if ((applications$ | async)?.length) {
        <div class="request-wrapper">
          @for (application of applications$ | async; track trackByAppId($index, application)) {
            <div
              class="ion-activatable ripple-parent"
              [class]="getType(application)"
              (click)="openChat(application)"
            >
              <ion-ripple-effect></ion-ripple-effect>

              <div class="content-container">
                <div class="icon-wrapper">
                  <ion-icon
                    class="status"
                    [name]="getStatusIcon(application)"
                  ></ion-icon>
                </div>

                <div class="content-wrapper">
                  <div class="header">
                    <h4 class="label">{{ application.title }}</h4>

                    <div class="date-wrapper">
                      @if (!isApplicationRead(application.id)) {
                        <ion-icon
                          class="icon-status new-message"
                          name="mail"
                        ></ion-icon>
                      }
                      @if (isApplicationRead(application.id)) {
                        <ion-icon
                          class="icon-status"
                          name="mail-open-outline"
                        ></ion-icon>
                      }
                      <p class="date">{{ getDate(application) | date: 'dd.MM.yyyy' }}</p>
                    </div>
                  </div>

                  <div class="message-preview">
                    <p
                      class="text"
                      [class.not-read]="!isApplicationRead(application.id)"
                      [class.two-line]="true"
                      [class.muted]="true"
                    >
                      {{ getPreviewMessage(application) }}
                    </p>
                  </div>

                  @if ((application | fromTo)?.from || (application | fromTo)?.to) {
                    <div class="from-to-wrapper">
                      <ion-icon name="calendar-outline"></ion-icon>
                      <div class="from-to">
                        @if ((application | fromTo)?.from) {
                          <p>{{ (application | fromTo)?.from }}</p>
                        }
                        @if ((application | fromTo)?.to) {
                          <span>–</span>
                        }
                        @if ((application | fromTo)?.to) {
                          <p>{{ (application | fromTo)?.to }}</p>
                        }
                      </div>
                    </div>
                  }
                </div>

                <div class="arrow-wrapper">
                  <ion-icon name="chevron-forward" />
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (showLoadButton) {
        <ion-button
          class="load-more-button"
          (click)="loadMoreApplications()"
        >
          <ion-icon
            slot="start"
            name="add-circle-outline"
          ></ion-icon>
          {{ 'Show_More' | translate }}
        </ion-button>
      }
    </div>
  }

  <!-- New Request content -->
  @if (selectedPage() === 'requests-create') {
    <div
      class="page-content requests-create"
      rotaAnimate
      [delayShowAnimation]="300"
      [animationShowTransitionMS]="300"
      [animationHideTransitionMS]="300"
      [animateToggle]="selectedPage() === 'requests-create'"
    >
      <div class="content-container">
        <rota-setupable-form
          [fieldGroups$]="fieldGroups$"
          (customSubmit)="handleSubmit($event)"
          (cancel)="goBack()"
        >
        </rota-setupable-form>
      </div>
    </div>
  }
</ion-content>
